// src/hooks/AuthContext.js
import {
  useState,
  useEffect,
  createContext,
  useCallback,
} from "react";
import { User, Auth } from "../api";
import { hasexpiredToken } from "../Utils";
import { Loader } from "semantic-ui-react";

const userController = new User();
const authController = new Auth();

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    authController.removeTokens();
    setUser(null);
    setToken(null);
  }, []);

  const login = useCallback(
    async (accessToken, userData = null) => {
      try {
        if (!accessToken) {
          throw new Error("No se recibió accessToken");
        }

        let u = userData;
        if (!u) {
          console.log(
            "Cargando datos del usuario desde la API con el token..."
          );
          u = await userController.getMe(accessToken);
        }

        if (!u) {
          throw new Error("No se pudieron obtener datos de usuario");
        }

        delete u.password;
        setUser(u);
        setToken(accessToken);
      } catch (error) {
        console.error("Error al autenticar:", error);
        logout();
      }
    },
    [logout]
  );

  const reLogin = useCallback(
    async (refreshToken) => {
      try {
        const { accessToken: newAccessToken } =
          await authController.refreshAccessToken(refreshToken);
        authController.setAccessToken(newAccessToken);
        await login(newAccessToken);
      } catch (error) {
        console.error("Error al refrescar token:", error);
        logout();
      }
    },
    [login, logout]
  );

  useEffect(() => {
    (async () => {
      try {
        const storedAccess = authController.getAccessToken();
        const storedRefresh = authController.getRefreshToken();

        if (!storedAccess || !storedRefresh) {
          logout();
          return;
        }

        if (hasexpiredToken(storedAccess)) {
          if (hasexpiredToken(storedRefresh)) {
            logout();
          } else {
            await reLogin(storedRefresh);
          }
        } else {
          await login(storedAccess);
        }
      } catch (error) {
        console.error("AuthProvider error:", error);
        logout();
      } finally {
        setLoading(false);
      }
    })();
  }, [login, reLogin, logout]);

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader active inline="centered" size="large">
          Cargando...
        </Loader>
      </div>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        accessToken: token,
        user,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
